import axiosClient from "../../common/axios/axiosConfig";

export const notifyAccess = (telemedicineToken: string) => {
  axiosClient.post(`/room/notify-access`, null, {
    headers: {
      Authorization: `Bearer ${telemedicineToken}`,
    },
  });
};
